import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  CRow,
  CCol,
  CLabel,
  CSelect,
  CInput,
  CButton
} from "@coreui/react";
import ApiHelper from "src/utils/api/api_helper";
import Swal from "sweetalert";
import { setGrpBrNo, setBrNo } from "src/modules/insert";

const SearchBrNm = (props) => {
  const { 
    corpNo, 
    closePopup,
    setResult,
    applyBrNm,
    searchBrInfo 
  } = props;

  function handleOpenSearchBrNm() {
    const { value } = document.getElementById('brNm');
    let params = {};

    params.brNm = value;
    params.corpNo = corpNo;

    if(value.length < 2) return Swal('협회등록지점 검색', '2자 이상 입력하세요.', 'info');

    ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/search-br-nm",
      params
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          const result = data.data;

          setResult(result);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  function handleOnClick() {
    const list = document.getElementsByName('qualificationYn');
    let length = 0;

    list.forEach((radio) => {
      if (radio.type === 'radio' && radio.checked)
      {
          length++;
      }
    });

    return applyBrNm(length);
  }

  return (
    <div className="layer-popup">
      <div className="box-popup popup-sign">
        <button
          className="popup-close"
          onClick={() => closePopup()}
          type="button"
        >
          {' '}
        </button>
        <div className="popup-title">협회등록지점 검색</div>
        <div className="popup-contents">
          <span className="txt-label">검색 시 2자이상 입력해야 합니다.</span>
          <CRow>
            <CCol xs="8" className="mt-4 mb-2">
              <CInput
                type="text"
                id="brNm"
                name="brNm"
              />
            </CCol>
            <CCol xs="4" className="mt-4 mb-2">
              <CButton
                type="button"
                color="primary"
                onClick={handleOpenSearchBrNm}
                >
                검색
              </CButton>
            </CCol>
          </CRow>
          <fieldset className="search-fileset">
          { searchBrInfo.length > 0 
          ? searchBrInfo.map((item) =>{
              return (
                <CRow key={item.BR_NO}>
                  <CCol xs="12" className="ml-10 mb-2 mt-2">
                      <label className="component-radio type-default">
                        <input type="radio" name="qualificationYn" data-grp-br-no={item.GRP_BR_NO} value={item.BR_NO} />
                        <i />
                        <div className="text-label">{item.BR_NM}</div>
                      </label>
                  </CCol>
                </CRow>
              )
            })
            : <span>검색해 주세요.</span>
          }
          </fieldset>
        </div>
        <div className="popup-footer">
          <button className="btn-footer" type="button" onClick={() => closePopup()}>
            닫기
          </button>
          <button className="btn-footer type-solid" type="button" onClick={handleOnClick}>
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

const BrInfo = (props) => {
  const { buBrList, brList, handleInputChange } = props;
  const { insert, main } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { corpNm, corpNo } = main;
  const { brNo, buBrNo } = insert.reqTaskInfo;
  const [showPopup, setShowPopup] = React.useState(false);
  const [searchBrInfo, setSearchBrInfo] = React.useState([]);

  React.useEffect(() => {
    if(buBrList.length == 1 && brList.length == 1){
      dispatch(setGrpBrNo(buBrList[0].BR_NO));
      dispatch(setBrNo(brList[0].BR_NO));
    }
  }, [brNo, buBrNo]);


  function openPopup() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    setShowPopup(true);
  }
  async function closePopup() {
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
    await setSearchBrInfo([]);
    await setShowPopup(false);
  }
  async function setResult(result) {
    setSearchBrInfo(result);
  }
  async function applyBrNm(length) {
    if(!length) return Swal('협회등록지점 검색', '검색 후 원하는 지점명을 선택하세요', 'info');

    document.getElementsByTagName("body")[0].style.overflow = "scroll";

    const target = document.querySelector('input[name="qualificationYn"]:checked');
    const { grpBrNo } = target.dataset;
    const brNo = target.value;

    await dispatch(setGrpBrNo(grpBrNo));
    await dispatch(setBrNo(brNo));
    await setShowPopup(false);
    await setSearchBrInfo([]);
  }

  let grpBrNmTxt = "";
  if(corpNm === 'gfk'){
    grpBrNmTxt='부문';
  }else if(corpNm === 'onef'){
    grpBrNmTxt= '사업단';
  }else if(corpNm === 'metarich' || main.corpNm == "LS-FC" || main.corpNm == "LS-EFA"){
    grpBrNmTxt='본부';
  }else if(corpNm === 'sky'){
    grpBrNmTxt='권역';
  }else{
    grpBrNmTxt = '총괄';
  }

  return (


    <>
      <CRow>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>{grpBrNmTxt}
          </CLabel>
          <CSelect
            custom
            name="buBrNo"
            id="buBrNo"
            value={insert.reqTaskInfo.buBrNo || ""}
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          >
          { buBrList.length == 1 && brList.length == 1 ?
          <>
            <option key={buBrList[0].BR_NO} value={`${buBrList[0].BR_NO}`}>
              {buBrList[0].BR_NM}
            </option> 
            </>
            :
            <>
              <option value="">선택</option>
              {buBrList.map((buBr) => (
                <option key={buBr.BR_NO} value={`${buBr.BR_NO}`}>
                  {buBr.BR_NM}
                </option>
              ))}
            </> 
          }
          </CSelect>
        </CCol>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>{((corpNm === 'onef' || corpNm === 'sky') ?  "본부" : (main.corpNm == "LS-FC" || main.corpNm == "LS-EFA") ? "지사" : "협회등록지점")}
          </CLabel>
          {corpNm !== 'megainfo' ? 
          <>
            <CButton
              type="button"
              color="primary"
              size="sm"
              className="brSearchBtn"
              onClick={openPopup}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            >
              지점명 검색
            </CButton>
          </> 
          : false }
          <CSelect
            custom
            name="brNo"
            id="brNo"
            value={insert.reqTaskInfo.brNo || ""}
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          >
            { buBrList.length == 1 && brList.length == 1 ?
            <option
              key={brList[0].BR_NO}
              data-bu-br-no={brList[0].GRP_BR_NO}
              value={`${brList[0].BR_NO}`}
            >
              {brList[0].BR_NM}
            </option>
            :
            <>
              <option value="">선택</option>
              {brList.map(
                (br) =>
                  Number(br.GRP_BR_NO) ===
                    Number(insert.reqTaskInfo.buBrNo) && (
                    <option
                      key={br.BR_NO}
                      data-bu-br-no={br.GRP_BR_NO}
                      value={`${br.BR_NO}`}
                    >
                      {br.BR_NM}
                    </option>
                  )
              )}
            </>
            }
          </CSelect>
        </CCol>
      </CRow>
      {
        showPopup && 
        <SearchBrNm 
          corpNo={corpNo} 
          closePopup={closePopup}
          applyBrNm={applyBrNm}
          setResult={setResult}
          searchBrInfo={searchBrInfo}>
        </SearchBrNm>
      }
    </>
  )
}

export default React.memo(BrInfo);